import { render, staticRenderFns } from "./GoBackButton.vue?vue&type=template&id=30604d30&scoped=true&"
import script from "./GoBackButton.vue?vue&type=script&lang=js&"
export * from "./GoBackButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30604d30",
  null
  
)

export default component.exports